import { LoadState } from "../../../constants/enums";

export interface IBusinessPolicySOVState {
  list: {
    data: ISOVImportRecord[];
    loading: LoadState;
    totalRecords: number;
  };
  submission: {
    loading: LoadState;
    error: string | null;
  };
}

export interface ISOVImportRecord {
  file_name: string;
  file_path: string;
  term: string;
  number_of_risk_location: string | number;
  total_combined_value: string | number;
  total_combined_cost: string | number;
  created_date: string;
  created_by: string;
  modified_date: string;
  modified_by: string;
  [key: string]: any;
}

export interface ISOVImportPayload {
  file_path: string;
  file_type: "Excel" | "Pdf";
  start_row?: number;
  end_row?: number;
}

export interface ISOVFetchParams {
  customer_policy_id: number;
  pageNo: number;
  pageLimit: number;
  itemPerPage: number;
  from_date?: string;
  to_date?: string;
  advanceFilter?: Record<string, any>;
}

export const defaultBusinessPolicySOVState: IBusinessPolicySOVState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
  },
  submission: {
    loading: LoadState.NotLoaded,
    error: null,
  },
};
